/** @typedef {{ id: number; name: string; displayOrder: number; label: string }} FloorLocation */
import axios from "../../utils/axios";

/** @returns {Promise<Array<FloorLocation>>} */
export function getFloorLocations() {
  return axios.get("/FloorLocation/GetFloorLocations");
}